import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Typography, Link, Paper } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import PasswordTextField from 'components/Input/PasswordTextField';
import CustomButton from 'components/CustomInput/Button/index';
import { useDispatch, useSelector } from 'react-redux';
import API from 'api/call';
import MsgBox from 'components/MsgBox/MsgBox';
import { setGlobalLoading } from 'store/global/reducer';
import { SYSTEM_HANDLE_FORCE_CHECK_VALIDATION } from 'store/key';

const useStyles = makeStyles((theme) => ({
    container: {
        marginTop: theme.spacing(4),
        flex: 1,
        overflow: 'auto',
    },
    box: {
        width: 500,
        padding: theme.spacing(2),
    },
    title: {
        fontWeight: 'bold',
        fontSize: '24px',
        paddingBottom: theme.spacing(4),
    },
    item: {
        marginTop: theme.spacing(2),
    },
    footer: {
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(2),
    },
}));

const ResetPassword = (props) => {
    const classes = useStyles();
    const dispatch = useDispatch();

    const { setIsResetPasswordUrl } = props;
    const history = useHistory();
    const token = history.location.search.split('?token=')[1];

    const systemMessage = useSelector(state => state.systemMessage.systemMessage);

    const [warningMsg, setWarningMsg] = useState(null);
    
    const [formData, setFormData] = useState({
        password: {
            value: '',
            label: 'Password',
            name: 'password',
            type: 'password',
        },
        confirmPassword: {
            value: '',
            label: 'Confirm Password',
            name: 'confirmPassword',
            type: 'password',
        },
    });
    const [forceShowError, setForceShowError] = useState(false);
    const [passwordValid, setPasswordValid] = useState(true);
    const [confirmPasswordValid, setConfirmPasswordValid] = useState(true);

    const checkFormDataValid = () => {
        let isValid = true;
        for (let i in formData) {
            if (!formData[i].value) {
                isValid = false;
                break;
            };
        }
        return isValid;
    };

    const handleFormDataChange = (e) => {
        const { name, value } = e.target;

        setFormData({
            ...formData,
            [name]: {
                ...formData[name],
                value: value
            },
        });
    };

    const confirm = () => {
        //update global state isLogin in user reducer
        setForceShowError(true);
        if (passwordValid && confirmPasswordValid && checkFormDataValid()) {
            setGlobalLoading(true);
            API.user.resetPassword({
                token: token, 
                password: formData.password.value,
                confirmPassword: formData.confirmPassword.value,
            }).then(res => {
                if(res != null) {
                    setWarningMsg({
                        type: 'confirm',
                        message: systemMessage.resetPassCodeSuccess,
                        footerActions: [
                            {
                                label: 'Confirm',
                                clicked: () => {
                                    setWarningMsg(null);
                                    back();
                                },
                            },
                        ],
                    });
                }
            }).finally(() => {
                setGlobalLoading(false);
            });
        }
    };
    const back = () => {
        setIsResetPasswordUrl(false);
        history.replace('/');
    };
    const reset = () => {
        setFormData({
            ...formData,
            password: {...formData.password, value: ''},
            confirmPassword: {...formData.confirmPassword, value: ''},
        });
        dispatch({
            type: SYSTEM_HANDLE_FORCE_CHECK_VALIDATION,
            payload: {
                forceCheckValidation: true
            },
        });
    };
    return (
        <Grid container wrap="nowrap" direction="column" alignItems="center" justify="center" className={classes.container}>
            {warningMsg && (
                <MsgBox
                    type={warningMsg.type}
                    message={warningMsg.message}
                    footerActions={warningMsg.footerActions}
                    title={warningMsg.title}
                    closePopup={() => setWarningMsg(null)}
                />
            )}
            <Paper className={classes.box}>
                <Grid container className={classes.title} style={{ fontSize: 18, fontWeight: 'bold' }}>
                    Reset password.
                </Grid>
                <Grid container alignItems="center" className={classes.item}>
                    <Grid container direction="column">
                        <PasswordTextField
                            name="password"
                            label="Password"
                            value={formData.password.value}
                            handleChange={handleFormDataChange}
                            validators={['isRequired', 'disableChinese', 'checkPassword']}
                            isValidValue={valid => setPasswordValid(valid)}
                            forceErrorDisplay={forceShowError}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
                <Grid container alignItems="center" className={classes.item}>
                    <Grid container direction="column">
                        <PasswordTextField
                            name="confirmPassword"
                            label="Confirm Password"
                            value={formData.confirmPassword.value}
                            handleChange={handleFormDataChange}
                            validators={['isRequired', 'disableChinese', 'checkConfirmPassword']}
                            isValidValue={valid => setConfirmPasswordValid(valid)}
                            forceErrorDisplay={forceShowError}
                            confirmPasswordNotMatchPassword={formData.confirmPassword.value !== formData.password.value}
                            maxLength={255}
                        />
                    </Grid>
                </Grid>
                <Grid container justify="space-between" className={classes.footer} wrap="nowrap">
                    <Grid container item xs={5}>
                        <CustomButton fullWidth onClick={reset}>
                            Reset
                        </CustomButton>
                    </Grid>
                    <Grid container item xs={5}>
                        <CustomButton fullWidth onClick={confirm}>
                            Confirm
                        </CustomButton>
                    </Grid>
                </Grid>
                <Grid container justify="center">
                    <Typography>
                        <Link href="#" onClick={back}>
                            Back to Login
                        </Link>
                    </Typography>
                </Grid>
            </Paper>
        </Grid>
    );
};

export default ResetPassword;
